import { subscribe } from '@/utils'

import { Params, Response } from '.'

const submit = async (params: Params): Promise<Response> => {
	try {
		const { payment_method, ...body } = params
		const endpoint = payment_method 
			? `sales/payment/${payment_method}` 
			: 'sales/pay'
		const res = await subscribe.post<Response>(endpoint, body)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	submit
}
